import { render, staticRenderFns } from "./RegisterViaPartnerVenue.vue?vue&type=template&id=53328cdf&scoped=true"
import script from "./RegisterViaPartnerVenue.vue?vue&type=script&lang=js"
export * from "./RegisterViaPartnerVenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53328cdf",
  null
  
)

export default component.exports